module.exports = "/_next/static/images/61caef71ef4de9790b085261f799c102-people-smile-at-home-md@2x.jpg";